import { authProvider } from './Security';
import { OpenAPI as KeymasterAPI } from './keymaster';
import { OpenAPI as KeymasterV2API } from './V2/keymaster';
import { OpenAPI as GozerV2API } from './V2/gozer';
import { OpenAPI as PadreAPI } from './padre';
import { OpenAPI as PadreV2API } from './V2/padre';
import { OpenAPI as LonghornAPI } from './longhorn';
import { OpenAPI as LonghornV2API } from './V2/longhorn';
import { OpenAPI as AurascopeAPI } from './aurascope';
import { OpenAPI as AurascopeV2API } from './V2/aurascope';
import { dateToLocal, handleError } from '../components/shared/Functions';

/* API configuration */
KeymasterAPI.BASE = ""
KeymasterV2API.BASE = ""
GozerV2API.BASE = ""
PadreAPI.BASE = ""
PadreV2API.BASE = ""
LonghornAPI.BASE = ""
LonghornV2API.BASE = ""
AurascopeAPI.BASE = ""
AurascopeV2API.BASE = ""

/* Always get latest token from NexusAuthprovider */
KeymasterAPI.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
KeymasterV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

GozerV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

PadreAPI.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
PadreV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

LonghornAPI.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
LonghornV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

AurascopeAPI.TOKEN = async () => {
    return await authProvider.getNexusToken()
}
AurascopeV2API.TOKEN = async () => {
    return await authProvider.getNexusToken()
}

export type IAccessToken = {
    token: string,
    tokenType: string,
    tokenExpires: Date,
    refreshToken: string,
    refreshTokenExpires: Date,
    createdAt: Date,
}


export async function getAccessToken(idToken: string): Promise<IAccessToken> {
    let getToken = new Promise<IAccessToken>(resolve => {
        fetch("/api/v2/Auth/AD/Vigo/AccessToken", {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + idToken,
                'Content-Type': 'application/json'
            }
        })
            .then(r => r.json())
            .then((response: IAccessToken) => {
                resolve({
                    ...response,
                    tokenExpires: dateToLocal(response.tokenExpires),
                    refreshTokenExpires: dateToLocal(response.refreshTokenExpires)
                })
            })
            .catch(err => {handleError(err);})
    })
    return getToken;
}

export async function getRefreshToken(refreshToken: string): Promise<IAccessToken> {
    let getToken = new Promise<IAccessToken>(resolve => {
        fetch("/api/v2/Auth/RefreshToken", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                refreshToken
            })
        })
            .then(r => r.json())
            .then((response: IAccessToken) => {
                resolve({
                    ...response,
                    tokenExpires: dateToLocal(response.tokenExpires),
                    refreshTokenExpires: dateToLocal(response.refreshTokenExpires)
                })
            })
            .catch(err => {handleError(err);})
    })
    return getToken;
}

export async function sendCodeForAdminLogin(user): Promise<string> {
    let getToken = new Promise<string>((resolve, reject) => {
        fetch("/api/v2/Auth/AccessToken", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(r => {
                if(r.status === 200){
                    r.text().then(response => {
                        resolve(response)
                    })
                } else {
                    r.json().then(x => reject(x))
                }
            })
    })
    return getToken;
}
export async function getAdminAccessToken(user, code): Promise<IAccessToken> {
    let getToken = new Promise<IAccessToken>((resolve, reject) => {
        fetch(`/api/v2/Auth/AccessCode?accessCode=${code}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(r => {
                if(r.status === 200){
                    r.json().then(response => {
                        resolve({
                            ...response,
                            tokenExpires: dateToLocal(response.tokenExpires),
                            refreshTokenExpires: dateToLocal(response.refreshTokenExpires)
                        })
                    })
                } else {
                    r.json().then(x => reject(x))
                }
            })
    })
    return getToken;
}